import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c47b4c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "root" }
const _hoisted_2 = {
  key: 1,
  class: "payment_schedule_section"
}
const _hoisted_3 = { class: "my-0" }
const _hoisted_4 = { class: "payment_schedule_legend" }
const _hoisted_5 = { class: "payment_schedule_legend_entry" }
const _hoisted_6 = ["onMouseenter"]
const _hoisted_7 = {
  key: 0,
  class: "payment_schedule_freeze_label"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["aria-label", "onMouseenter", "onFocus", "onClick"]
const _hoisted_10 = { class: "payment_schedule_tooltip_header" }
const _hoisted_11 = { class: "payment_schedule_tooltip_title" }
const _hoisted_12 = {
  key: 0,
  class: "payment_schedule_tooltip_subtitle"
}
const _hoisted_13 = { class: "payment_schedule_tooltip_rows" }
const _hoisted_14 = { class: "payment_schedule_tooltip_row" }
const _hoisted_15 = { class: "payment_schedule_tooltip_row_text" }
const _hoisted_16 = {
  key: 0,
  class: "payment_schedule_tooltip_row_note"
}
const _hoisted_17 = {
  key: 0,
  class: "payment_schedule_tooltip_total"
}
const _hoisted_18 = { class: "payment_schedule_tooltip_note" }
const _hoisted_19 = { class: "payment_schedule_timeline" }
const _hoisted_20 = { class: "payment_schedule_label" }
const _hoisted_21 = {
  key: 0,
  class: "payment_schedule_period"
}
const _hoisted_22 = { class: "payment_schedule_note" }
const _hoisted_23 = { class: "payment_schedule_note_text" }
const _hoisted_24 = ["href", "onClick"]

export function render(_ctx, _cache) {
  const _component_paymentExplanationModal = _resolveComponent("paymentExplanationModal")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.explanationOrderId)
      ? (_openBlock(), _createBlock(_component_paymentExplanationModal, {
          key: 0,
          orderId: _ctx.explanationOrderId,
          onClose: _cache[0] || (_cache[0] = $event => (_ctx.explanationOrderId = null))
        }, null, 8, ["orderId"]))
      : _createCommentVNode("", true),
    (_ctx.isWideScreen && _ctx.columnViews.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('contract.view.payment_schedule.title')), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legend, (entry) => {
              return (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass('payment_schedule_swatch payment_schedule_segment_' + entry.tone)
                }, null, 2),
                _createTextVNode(_toDisplayString(entry.text), 1)
              ]))
            }), 256))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass('payment_schedule_chart' + (_ctx.freezeViews.length > 0 ? ' payment_schedule_chart_with_freezes' : '')),
            onMouseleave: _cache[2] || (_cache[2] = $event => (_ctx.hovered = null))
          }, [
            (_ctx.today)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    class: "payment_schedule_today_line",
                    style: _normalizeStyle({ left: _ctx.today.x + '%' })
                  }, null, 4),
                  _createElementVNode("span", {
                    class: "payment_schedule_today_label",
                    style: _normalizeStyle({ left: _ctx.today.x + '%' })
                  }, _toDisplayString(_ctx.$t('contract.view.payment_schedule.today', { date: _ctx.today.dateText })), 5)
                ], 64))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freezeViews, (freeze, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "payment_schedule_freeze",
                style: _normalizeStyle({ left: freeze.left + '%', width: freeze.width + '%' }),
                onMouseenter: $event => (_ctx.hovered = { type: 'freeze', index: index })
              }, [
                (freeze.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createElementVNode("b", null, _toDisplayString(freeze.label), 1),
                      (freeze.period)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(freeze.period), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 44, _hoisted_6))
            }), 256)),
            _createElementVNode("div", {
              class: "payment_schedule_bars",
              style: _normalizeStyle(_ctx.gridStyle)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnViews, (column, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  type: "button",
                  class: _normalizeClass('payment_schedule_bar_button' + (column.orderId ? ' payment_schedule_bar_button_clickable' : '')),
                  "aria-label": column.dateText + ', ' + column.amountText,
                  onMouseenter: $event => (_ctx.hovered = { type: 'column', index: index }),
                  onFocus: $event => (_ctx.hovered = { type: 'column', index: index }),
                  onBlur: _cache[1] || (_cache[1] = $event => (_ctx.hovered = null)),
                  onClick: $event => (_ctx.openExplanation(column.orderId))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass('payment_schedule_amount' + (column.isMuted ? ' payment_schedule_amount_muted' : ''))
                  }, _toDisplayString(column.amountText), 3),
                  _createElementVNode("span", {
                    class: "payment_schedule_bar",
                    style: _normalizeStyle({ height: column.barHeight + 'px' })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.segments, (segment) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass('payment_schedule_segment payment_schedule_segment_' + segment.tone),
                        style: _normalizeStyle({ height: segment.height + 'px' })
                      }, null, 6))
                    }), 256))
                  ], 4)
                ], 42, _hoisted_9))
              }), 256))
            ], 4),
            (_ctx.tooltip)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "payment_schedule_tooltip",
                  style: _normalizeStyle(_ctx.tooltip.style)
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.tooltip.title), 1),
                    (_ctx.tooltip.subtitle)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.tooltip.subtitle), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tooltip.rows, (row) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, [
                          _createElementVNode("span", null, _toDisplayString(row.name), 1),
                          (row.note)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row.note), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass('payment_schedule_tooltip_row_amount payment_schedule_note_' + row.tone)
                        }, _toDisplayString(row.amount), 3)
                      ]))
                    }), 256))
                  ]),
                  (_ctx.tooltip.total)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.tooltip.totalLabel), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.tooltip.total), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tooltip.notes, (note) => {
                    return (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(note), 1))
                  }), 256))
                ], 4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "payment_schedule_timeline_past",
                style: _normalizeStyle({ width: _ctx.timelinePastWidth + '%' })
              }, null, 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnViews, (column) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass('payment_schedule_pin' + (column.isPaidLate ? ' payment_schedule_pin_paid_late' : column.isPaid ? ' payment_schedule_pin_paid' : '')),
                  style: _normalizeStyle({ left: column.center + '%' })
                }, null, 6))
              }), 256))
            ]),
            _createElementVNode("div", {
              class: "payment_schedule_labels",
              style: _normalizeStyle(_ctx.gridStyle)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnViews, (column) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("span", {
                    class: _normalizeClass('payment_schedule_date' + (column.isFreeMonth ? ' payment_schedule_date_cancelled' : ''))
                  }, _toDisplayString(column.dateText), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass('payment_schedule_status payment_schedule_status_' + column.kind)
                  }, _toDisplayString(column.statusText), 3),
                  (column.periodText)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(column.periodText), 1))
                    : _createCommentVNode("", true),
                  (column.orderId)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: "payment_schedule_link",
                        to: '/order/' + column.orderId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("#" + _toDisplayString(column.orderNumber), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.notes, (note) => {
                    return (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createElementVNode("span", {
                        class: _normalizeClass('payment_schedule_note_amount payment_schedule_note_' + note.tone)
                      }, _toDisplayString(note.amount), 3),
                      _createElementVNode("span", _hoisted_23, [
                        _createTextVNode(_toDisplayString(note.text), 1),
                        (note.friendClientId)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(":"),
                              _createElementVNode("a", {
                                class: "payment_schedule_link payment_schedule_friend_link",
                                href: '/client/' + note.friendClientId,
                                onClick: _withModifiers($event => (_ctx.openFriend(note.friendClientId)), ["prevent"])
                              }, _toDisplayString(note.friendClientName), 9, _hoisted_24)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(note.suffix), 1)
                      ])
                    ]))
                  }), 256))
                ]))
              }), 256))
            ], 4)
          ], 34)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}